import React from 'react';

export const parseLogin = (val) => {
    if (+val) {
        return (
            <span style={{textTransform: val?.indexOf('@') === -1 && 'uppercase'}}>
                {`+ ${val?.slice(0, 1)} (${val?.slice(1, 4)}) ${val?.slice(4, 7)}-${val?.slice(7, 9)}-${val?.slice(9, 11)}`}
            </span>
        )
    } else {
        return (
            <span style={{textTransform: val.indexOf('@') === -1 && 'uppercase'}}>
                {val}
            </span>
        )
    }
}